import React, { useEffect, useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import CustomCheckBox from "../../atoms/CustomCheckBox";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { cancelBids } from "../../../utils/API/cancelbid";

const Cancelbid = ({ open, onCancel, onOk, bidId, viewBidOption = false }) => {
  const [isChecked, setChecked] = useState(false);
  const [agreeTermsError, setAgreeTermsError] = useState("");
  const [remarks, setRemarks] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isCancelBidSuccess, setCancelBidSuccess] = useState(false);
  const dispatch = useDispatch();

  const handleCancelCheck = () => {
    setChecked(!isChecked);
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const handleReasonChange = (event) => {
    setReason(event.target.value);
  };

  const handleCancelBidSuccess = async () => {
    if (reason === "" || remarks === "" || !isChecked) {
      if (reason === "") {
        setReasonError("Please give a reason before cancelling this bid");
      }
      if (remarks === "") {
        setRemarksError("Please give remarks before cancelling this bid");
      }
      if (!isChecked) {
        setAgreeTermsError("Please confirm before submit");
      }
    } else {
      try {
        setLoading(true);
        await cancelBids(bidId, remarks, reason, dispatch);
        setReasonError("");
        setReason("");
        setRemarksError("");
        setRemarks("");
        setAgreeTermsError("");
        onOk();
      } catch (error) {
        toast.error("Error cancelling bid");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCancel = () => {
    if (isChecked) {
      setChecked(false);
    }
    setReasonError("");
    setReason("");
    setRemarksError("");
    setRemarks("");
    setAgreeTermsError("");
    onCancel();
  };

  return (
    <DiaglogBox open={open} onCancel={handleCancel} width={617}>
      <div className="flex justify-center h-full pt-5">
        <div className="font-bold text-28 text-3xl">Cancel bid</div>
      </div>
      <div>
        <hr className="ml-8 w-[544px] border-t-2 text-zinc-500 my-4" />
        <div className="ml-8">
          <CustomCheckBox
            isChecked={isChecked}
            labelText="Are you sure you want to cancel this received bid"
            onChange={handleCancelCheck}
          />
        </div>
        <p className="text-red-500 text-xs mx-10">{agreeTermsError}</p>
        <hr className="ml-8 w-[544px] border-t-2 text-zinc-500 my-2" />
        <p className="ml-8">Reason</p>
        <div className="pt-2">
          {viewBidOption ? (
            <select
              className="ml-9 pl-3.5 w-[542px] h-[28px] text-sm font-normal leading-normal border text-zinc-500 rounded-lg"
              onChange={handleReasonChange}
              value={reason}
            >
              <option value="" disabled>
                Select the Reason
              </option>
              <option value="less_rate">Rate quoted is too less</option>
              <option value="not_liked_buyer_profile">
                Didn't link the Buyer's profile
              </option>
              <option value="demards_less_credits">
                Buyers demanding too less credits
              </option>
              <option value="others">Others</option>
            </select>
          ) : (
            <select
              className="ml-9 pl-3.5 w-[542px] h-[28px] text-sm font-normal leading-normal border text-zinc-500 rounded-lg"
              onChange={handleReasonChange}
              value={reason}
            >
              <option value="" disabled>
                Select the Reason
              </option>
              <option value="changed_my_mind">Changed my mind</option>
              <option value="seller_not_responding">
                Seller is not responding
              </option>
              <option value="better_offer_on_offset">
                Received a better offer on Offsetgo
              </option>
              <option value="better_offer_outside">
                Received a better offer elsewhere
              </option>
              <option value="others">Others</option>
            </select>
          )}
        </div>
        <p className="mx-10 text-red-500 text-xs mt-2">{reasonError}</p>
        <hr className="ml-8 w-[544px] border-t-2 text-zinc-500 my-3" />
        <div className="pl-9">
          <input
            type="text"
            value={remarks}
            onChange={handleRemarksChange}
            className="w-[542px] h-[71px] border text-gray-700 rounded-md pl-4"
            placeholder="Remarks"
          />
        </div>
        <p className="mx-10 text-red-500 text-xs mt-2">{remarksError}</p>
        <div className="pl-44 pt-3.5 pb-5">
          <Button
            variant="primary"
            color="blue"
            onClick={handleCancelBidSuccess}
            className="w-64 h-14 text-base text-white font-bold border-[1px]"
          >
            {loading ? <LoadingOutlined /> : "Submit"}
          </Button>
        </div>
      </div>
    </DiaglogBox>
  );
};

export default Cancelbid;
